export default __webpack_public_path__ + "static/media/logo.134309e5.png";